import { Badge } from '@shared/ui';

import { OUTCOME_LABEL, OUTCOME_TONE } from '../model/outcome-copy';

import type { TenantOutcome } from '../schemas/bulk-migration';

export function OutcomeBadge({ outcome }: { outcome: TenantOutcome }) {
    return (
        <Badge tone={OUTCOME_TONE[outcome]} dot>
            {OUTCOME_LABEL[outcome]}
        </Badge>
    );
}
